/* eslint-disable linebreak-style */
import { useRouteMatch } from 'react-router';
import { urls } from '../../Constants';
// eslint-disable-next-line object-curly-newline
import { BrandListPage, BrandCreatePage, BrandViewPage } from '../../Pages';
import CRUDRoutes from '../CRUD Routes/CRUD.routes';

const BrandRoutes = () => {
	const { path } = useRouteMatch();
	const breadcrumbs = [
		{
			link: `${urls.EXTENSION}${urls.BRANDS}`,
			name: 'My Brands',
		},
	];
	return (
		<CRUDRoutes
			entity='BRANDS'
			path={path}
			listPage={BrandListPage}
			viewPage={<BrandViewPage breadcrumbs={breadcrumbs} />}
			createPage={<BrandCreatePage breadcrumbs={breadcrumbs} />}
			editPage={<BrandCreatePage isEdit breadcrumbs={breadcrumbs} />}
		/>
	);
};

export default BrandRoutes;
